import { Service, service, inject } from './di'
import { i18n } from '../i18n/I18n'

import { LocationService } from './LocationService'

@service('FeedbackService')
export default class FeedbackService extends Service {
    @inject locationService: LocationService

    private feedbackKeysEn = [
        'feedback_text',
        'feedback_text_1',
        'feedback_text_2',
        'feedback_text_3',
        'feedback_text_4',
        'feedback_text_5',
        'feedback_text_6',
        'feedback_text_7',
        'feedback_text_8',
        'feedback_text_9',
        'feedback_text_10',
        'feedback_text_11',
    ]
    private feedbackKeysFr = [
        'feedback_text',
        'feedback_text_1',
        'feedback_text_2',
        'feedback_text_3',
        'feedback_text_4',
        'feedback_text_5',
        'feedback_text_6',
        'feedback_text_7',
        'feedback_text_8',
        'feedback_text_9',
    ]

    getFeedbackKeysArray() {
        return this.locationService.locale === 'fr-ca'
            ? this.feedbackKeysFr
            : this.feedbackKeysEn
    }

    getFeedback() {
        const feedbackKeys = this.getFeedbackKeysArray()
        const feedBackKey = this.getRandomFeedbackKey(feedbackKeys)
        return i18n(feedbackKeys[feedBackKey])
    }

    private getRandomFeedbackKey(feedbackKeys: any) {
        return this.getRandomValue(0, feedbackKeys.length)
    }

    private getRandomValue(min: number, max: number): number {
        min = Math.ceil(min)
        max = Math.floor(max)
        return Math.floor(Math.random() * (max - min)) + min
    }
}
